<template>
	<div class="homePage">
		
		<div class="head">			
			<div>
				<div class="left">LOGO</div>
				<div class="right">
					<div>
						<ul class="nav">
							<li><a href="">主机</a></li>
							<li><a href="">个人中心</a></li>
							<li><a href="">首页</a></li>
							<li><a href="">首页</a></li>
							<li><a href="">首页</a></li>
							<li><a href="">首页</a></li>
						</ul>
					</div>
					<div class="sear">
						<text class='search'></text>
						<input type="text" v-model="inputVal" :class="[{ inpuActive: isActive }]"  @mouseover ='inpuMouSeover' @mouseleave="inputMouseLeave"  @change="subSeach"/>
					</div>
				</div>
			</div>

		</div>
		<!-- 头部结束 -->
		<!-- brann图 -->
		<div class="brann">
			<img src="../assets/brann.jpg" alt="">
		</div>
		
		<!-- 列表 -->
		<ul class="list clearFix">
			<li class="one" @click="chanpinOne"><a> <img src="../assets/host.png" alt=""> <p>产品分类</p> </a> </li>
			<li class="two"><a href=""> <img src="../assets/host.png" alt=""> <p>产品分类</p> </a> </li>
			<li class="one"><a href=""> <img src="../assets/host.png" alt=""> <p>产品分类</p> </a> </li>
			<li class="two"><a href=""> <img src="../assets/host.png" alt=""> <p>产品分类</p> </a> </li>
			<li class="one"><a href=""> <img src="../assets/host.png" alt=""> <p>产品分类</p> </a> </li>
			<li class="two"><a href=""> <img src="../assets/host.png" alt=""> <p>产品分类</p> </a> </li>
		</ul>
		
		<!-- 产品展示 -->
		
		<div class="zhanshi">
			<div class="title">产品展示</div>
			<div class="Hconter">
				<ul class="listTitle">
					<li v-for="(item,index) in subTitle" @click="subTab(index,item)" :class="{active:subActive == index}"><a href="">{{item}}</a></li>
				<!-- 	<li><a href="">产品分类</a></li>
					<li><a href="">产品分类</a></li>
					<li><a href="">产品分类</a></li>
					<li><a href="">产品分类</a></li>
					<li><a href="">产品分类</a></li> -->
				</ul>
				<div class="listChanpin">
					<div class="item" @click="detail" v-for="item in list"> <img src="../assets/chanpin.jpg" /><p>产品名称产品名称产品名称产品名称产品名称</p> </div>
				</div>
				<!-- 分页 -->
				<div class="fenye">
					<el-pagination
						background
						layout="prev, pager, next"
						:total="1000">
					</el-pagination>
				</div>
				<!-- 分页结束 -->
			</div>
		</div>
		
	</div>
</template>

<script>
	export default{
		name:'homePage',
		data(){
			return{
				isActive:false,
				inputVal:'',
				subTitle:['产品分类','产品分类','产品分类','产品分类','产品分类','产品分类'],
				subActive:0,
				list:[1,1,1,1,1,1,1,1,1,1,1,1]
			}			
		},
		methods:{
			// 鼠标移入sear
			inpuMouSeover:function(){
				this.isActive = true
			},
			// 失去焦点
			shiqu:function(){
				if(this.inputVal ==''){
					this.isActive = false
				}
			},
			// 鼠标移出sear
			inputMouseLeave:function(){
			
			},
			// tab选择
			subTab:function(index,item){
				this.subActive = index
			},
			chanpinOne:function(){
				this.$router.push("/Jianjie")
			},
			// 提交搜索
			subSeach:function(e){
				console.log(e)
				this.$router.push('/search')
			},
			//产品详情
			detail:function(){
				this.$router.push('/detail')
			}
			
		}
	}
</script>

<style>
	*{
		margin: 0px;
		padding: 0px;
		box-sizing: border-box;
	}
	li{
		list-style: none;
	}
	li>a{
		color: #333333;
		text-decoration: none;
	}
/* 	a{
		width: 100%;
		height: 100%;
	} */
	ul{
		margin: 0px;
	}
	.clearFix::after{
		content: '';
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
	}
</style>
<style scoped>
	.fenye{
		text-align: right;
		margin: 60px 0px 30px;
	}
	.zhanshi{
		width: 1200px;
		margin: 40px auto 0px;
		text-align: center;
	}
	.title{
		width: 80px;
		padding: 5px 0px;
		margin: auto;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		border-bottom: 2px solid rgb(31,178,255);
	}
	.listTitle{
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 14px;
		margin: 20px 0px;
	}
	.listTitle li{
		width: 80px;
	}
	.listTitle li a{
		color: rgb(185,186,186);
	}
	.listTitle li.active a{
		color:  rgb(31,178,255);
		border-bottom: 1px solid  rgb(31,178,255);
	}
	.listChanpin{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
	}
	.listChanpin>.item{
/* 		width: 33%; */
		position: relative;
		height: 300px;
		margin: 20px 10px;
		width: 300px;
	}
	.listChanpin>.item img{
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
	}
	.listChanpin>.item p{
		background-color: rgb(244,245,249);
    color: #333333;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 280px;
    height: 40px;
    line-height: 40px;
    letter-spacing: 1px;
    padding: 10px 10px;
    margin: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
		font-size: 16px;
		box-sizing: content-box;
		color: rgb(137,140,146);
	}
	
	.list{
		width: 1200px;
		display: flex;
		justify-content: center;
		margin: -60px auto 0px;
		position: relative;
		z-index: 10;
	}
	.list p{
		 margin: 20px 0px;
	}
	.one{
		width: 140px;
		height: 140px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: rgb(39,85,161);
	}
	.two{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 140px;
		height: 140px;
		background-color: rgb(80,128,207);
	}
	.list li img{
		width: 30px;
		height: 30px;
	}
	.list li>a{
		color: white;
	}
	
	.brann{
		width: 100%;
		height: 400px;
		margin: 80px 0px 0px;
	}
	.brann>img{
		width: 100%;
		height:100%;
	}
	
	
	.head{
		width: 100%;
		height: 80px;
		line-height: 80px;		
		font-size: 14px;
		font-weight: 600;
		position: fixed;
		top: 0px;
		left: 0px;
		background-color: white;
		z-index: 30;
		box-shadow: 1px 1px 0.5 #EEEEEE;
	}
	.head>div{
		width: 1200px;
		margin: auto;
		display: flex;
		box-sizing: border-box;
		flex-direction: row;
		justify-content: space-between;
	}
	.head .left{
		
		width: 150px;
		background-color: rgb(39,85,161);
		color: white;
	}
	.right{
			display: flex;
			align-items: center;
	}
	.right .nav{
		width: 600px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0px 20px 0px auto;
	}
	.right .nav li a{
		padding: 10px 0px;
	}
	
	.right .nav li:hover>a{
		border-bottom: 1px solid rgb(39,85,161);
	}
	.right .sear{
		margin: 0px 10px;
		width: 160px;
		text-align: left;
	}
	.right .sear>input{
		width: 40px;
		background-color:#4876FF;
		color: white;
		border: 0px;
		outline: inherit;
		height: 25px;
		line-height: 25px;
		border-radius: 20px;
		background-image: url(../assets/sear.png);
		background-size: 15px 15px;
		background-repeat: no-repeat;
		background-position: 10px 4px;
		cursor:pointer;
		transition: all 1s;
		padding-left: 30px;
	}
/*  */
	.right .sear>input.inpuActive{
		width: 160px;
	}
	
	
</style>



// WEBPACK FOOTER //
// src/components/home.vue